import { render, staticRenderFns } from "./ChangeOfPeriod.vue?vue&type=template&id=2918987a&scoped=true&"
import script from "./ChangeOfPeriod.vue?vue&type=script&lang=js&"
export * from "./ChangeOfPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfPeriod.vue?vue&type=style&index=0&id=2918987a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918987a",
  null
  
)

export default component.exports